import jquery from 'jquery';
import EFOcats_making from '../../../core/v1/making/efocats_making.js';
import EFOcats_import_html from '../../../core/v1/import/efocats_import_html.js';
import EFOcats_answer_retro_radio from '../answer/efocats_answer_retro_radio.js';
import EFOcats_import_style from '../../../core/v1/import/efocats_import_style.js';
// import EFOcats_answer_retro_checkbox from '../../../core/v1/answer/efocats_answer_checkbox.js';
// import EFOcats_answer_retro_common from '../answer/efocats_answer_retro_common.js';

// import EFOcats_answer_nini from '../answer/efocats_answer_retro_nini.js';
// import EFOcats_answer_retro_require from '../answer/efocats_answer_retro_required';

/**
 * レトロのmakingクラス
 */
export default class EFOcats_retro_making extends EFOcats_making {
  constructor() {
    super();
    //   // this.answersettings.common = new EFOcats_answer_retro_common();
    //   // this.answersettings.nini = new EFOcats_answer_nini();
    //   // this.answersettings.required = new EFOcats_answer_retro_require();
    this.answersettings.radio = new EFOcats_answer_retro_radio();
  }

  template(tmp, number) {
    if (tmp === 'set-retro-adress') {
      const tmphtml = require(`../html/${tmp}.html`);
      const elem = jquery(tmphtml);

      // ボタンを作成
      if (number === 0 && tmp !== 'page-start') {
        // 開始ページの場合
        elem.find('.container').append(EFOcats_import_html.getValue('btn_startpage_next'));
      } else if ((number !== 0 || tmp !== 'page-start') && tmp !== 'page-end') {
        elem.find('.container').append(EFOcats_import_html.getValue('btn_pager'));
      }
      return elem;
    }
    return super.template(tmp, number);
  }

  /**
   * フレームに対するスタイルを設定、設置する
   */
  // style() {
  //   super.style();
  // }

  base() {
    super.base();

    // 案件独自のファイルを読込み
    require('../scss/retro.scss');
    jquery(this.iframe).contents().find('head').append(jquery('head').find('style').last());

    this.efocats_style.innerText = EFOcats_import_style.getValue('frame-style');
  }

  // translation() {
  //   super.translation();
  //   if (this.$('.qa .next-btn-design.btn_pager_approval')) {
  //     this.$('.qa .next-btn-design.btn_pager_approval').html(this.langagerList('承認'));
  //   }
  // }

  page_extend(label_tmp, elem, number) {
    // ページタイトルを挿入する
    if (number === 0) {
      const first_text =
        '<h1 class="main_ttl" style="font-weight:bold; text-align:center;margin-bottom: 20px;"></h1><p style="font-weight:normal; font-size:14px; color:#333; text-align:center;">お電話でのお申込みは <a style="color:#333; font-size25px; text-decoration:underline;" href="tel:0120503840"><strong><u>0120-503-840</u></strong></a> まで</p><p style="margin:20px;text-align:center;text-decoration:underline;"><a style="color:#333; font-size:16px;" href="https://itaku.retro.jp/direct/" target="_blank">【お急ぎの方へ】お持ちの段ボールで直接送ってもOK！詳細はこちら</a></p>';
      jquery(elem).eq(0).find('.container').prepend(first_text);
      jquery(elem).find('.main_ttl').html(document.querySelector('.ttl-m80').innerHTML);
    }

    if (elem) {
      // その他個別でカスタムが必要な場合
      elem.find('.inner').each((index, element) => {
        if (jquery(element).hasClass('adress')) {
          jquery(element).children('.check-flag').remove();
        }

        if (jquery(element).find('textarea')) {
          jquery(element).find('textarea').parents('.check-flag').addClass('textarea');
        }
      });
    }
  }
}
